import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    DetailsMainContainer,
    MainContainerItems,
    Title,
} from './AccountSection.styled';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
  logErrorToConsole
} from 'src/utils/util';
const AccountSection = ({
    isAccountCardExpanded,
    setIsAccountCardExpanded,
    handleInputChange,
    accounts,
    accountId,
    AccountTemplate,
    accountValue,
    isAccountsOptionLoading,
    handleSearch,
    handleOnfocus,
    closeKeyBoard,
    cardWidth,
    onBlur,
    usageDetails,
}) => {
    const { t } = useTranslation();
    // const history = useHistory();
    // const edittedAccountName = history?.location?.state?.account;
    const [open, setOpen] = useState(false);
    const inputRef = useRef();
    useEffectWithErrorLogging(() => {
        if (accountValue.length >= 1 && accounts.length === 0) {
            setOpen(false);
        }
        if (accountValue.length < 1) {
            inputRef.current.focus();
        }
        if (
            accountValue &&
            (accountValue === usageDetails?.accountFormattedName ||
                accountValue === usageDetails?.originalAccountFormattedName)
        ) {
            closeKeyBoard();
        }
    }, [accounts, accountValue]);

    return (
        <>
            <CollapsableCard id="reportUsage-accountSection-changeAccount-account"
                title={t('reportUsage.record.account.title')}
                onClick={() => setIsAccountCardExpanded(!isAccountCardExpanded)}
                isExpanded={isAccountCardExpanded}
                currentActivity
                margin={'10px 0px 10px 0px'}
                width={cardWidth}
            >
                {isAccountCardExpanded ? (
                    <DetailsMainContainer>
                        <MainContainerItems setMarginBottom={true}>
                            <Title>
                                {t(
                                    'reportUsage.record.account.details.detailsTitle'
                                )}
                            </Title>
                            <AutoComplete
                                boxShadow={'0px 3px 6px #00000029'}
                                options={accounts}
                                inputRef={inputRef}
                                showScrollBar={true}
                                disableClearable={false}
                                value={accountId}
                                inputValue={accountValue}
                                itemTemplate={(option) =>
                                    AccountTemplate(option, 'account')
                                }
                                onChange={(value, reason) => {
                                    if (reason==='clear') {
                                        handleOnfocus(null, 'accounts');
                                    } else {
                                        setOpen(false);
                                    }
                                    handleInputChange('accountId', value);
                                    if(value==='') setOpen(true);
                                }}
                                hideNoOptionText={false}
                                loadingText={t('common.loadingText')}
                                noOptionsText={
                                    !isAccountsOptionLoading &&
                                    accounts?.length === 0
                                        ? t('common.noResultFoundText')
                                        : isAccountsOptionLoading &&
                                          t('common.loadingText')
                                }
                                placeholder={t(
                                    'reportUsage.record.account.details.placeholder'
                                )}
                                field="accountFormattedName"
                                filterField="filterValue"
                                optionValue="accountId"
                                id="reportUsage-record-changeAccount-account"
                                onInputChange={(event, value, reset) =>{
                                    if(value){
                                        handleSearch(event, value, reset, 'account');
                                    }   
                                    else if(reset==='clear'){
                                        handleSearch('', '', reset, 'account');
                                    }
                                    }
                                }
                                loading={isAccountsOptionLoading}
                                onFocus={(event) =>
                                    // handleOnfocus(event, 'accounts')
                                    setOpen(true)
                                }
                                onBlur={(event) => {
                                    onBlur(event);
                                    setOpen(false);
                                }}
                                onOpen={() => {
                                    try {
                                    setOpen(true);
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                onClose={() => {
                                    try {
                                    setOpen(false);
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                open={accountId?false : open}
                                readOnly={accountId}
                                detailsMargin
                                marginLeft={'1.5px'}
                                clearOnBlur={true}
                                zIndex={'9999'}
                                ListboxProps={{ style: { maxHeight: 'auto' } }}
                            />
                        </MainContainerItems>
                    </DetailsMainContainer>
                ) : null}
            </CollapsableCard>
        </>
    );
};

AccountSection.propTypes = {
    isAccountCardExpanded: PropTypes.bool,
    setIsAccountCardExpanded: PropTypes.func,
    handleInputChange: PropTypes.func,
    accounts: PropTypes.array,
    accountId: PropTypes.string,
    AccountTemplate: PropTypes.element,
    accountValue: PropTypes.string,
    isAccountsOptionLoading: PropTypes.bool,
    handleSearch: PropTypes.func,
    handleOnfocus: PropTypes.func,
    closeKeyBoard: PropTypes.func,
    cardWidth: PropTypes.string,
    onBlur: PropTypes.func,
};

export default AccountSection;
